export const graphCanvasRoute = {
    patterns: {
        graphCanvas: '/canvas',
    },
} as const;
